// Stat card used by Reference Data, Rules summaries, and dashboard sections.
export function Card({ label, value, color }) {
  return (
    <div
      style={{
        padding: '10px 18px',
        background: '#fff',
        borderRadius: 8,
        boxShadow: '0 1px 4px rgba(0,33,89,0.08)',
        minWidth: 110,
        textAlign: 'center',
        borderTop: `3px solid ${color || '#002159'}`,
      }}
    >
      <div style={{ fontSize: 22, fontWeight: 700, color: color || '#002159' }}>
        {value}
      </div>
      <div style={{ fontSize: 11, color: '#666', marginTop: 2 }}>{label}</div>
    </div>
  );
}
